const verify = {
    //退回公众号菜单
    closePage() {
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            weixin_ClosePage,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", weixin_ClosePage);
          document.attachEvent("onWeixinJSBridgeReady", weixin_ClosePage);
        }
      } else {
        window.WeixinJSBridge.call("closeWindow");
      }
    },
    //获取页面路径
    getConfigData() {
      let jsUrl = ''
      const u = navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      const isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  
      if (isAndroid) {
        jsUrl = window.location.href
      } else if (isIos) {
        jsUrl = location.href.replace(location.hash, '')
      }
      return jsUrl
    },
    //获取页面参数
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },
    //手机号校验
    verifyPhone(phone) {
      var reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
      console.log(reg.test(phone));
      if (reg.test(phone)) {
        return false //手机号格式错误
      } else {
        return true //手机号格式正确
      }
    },
    //时间格式转字符串
    verifyDate(date, type) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? ('0' + m) : m;
      var d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      var h = date.getHours();
      var minute = date.getMinutes();
      minute = minute < 10 ? ('0' + minute) : minute;
      var second = date.getSeconds();
      second = minute < 10 ? ('0' + second) : second;
      if (type) {
        return y + '-' + m + '-' + d;
      }
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return null;
    }
  }
  
  
  export default verify
  


// WEBPACK FOOTER //
// ./src/api/tool.js